
const Character = ({ position, size, window, img, zIndex }) => {

    return (
        <div
            style={{
                position: 'absolute',
                left: position.x,
                top: position.y,
                width: size.width,
                height: size.height,
                zIndex: zIndex
            }}
        ><img src={img} style={{height: size.height,  imageRendering: 'pixelated'}} alt="fireSpot"/></div>
    );
};

export default Character;
